import { render, staticRenderFns } from "./InformacionGeneralOdt.vue?vue&type=template&id=0a5705f6&scoped=true"
import script from "./InformacionGeneralOdt.vue?vue&type=script&lang=js"
export * from "./InformacionGeneralOdt.vue?vue&type=script&lang=js"
import style0 from "./InformacionGeneralOdt.vue?vue&type=style&index=0&id=0a5705f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5705f6",
  null
  
)

export default component.exports